import { Grid, Typography } from "@mui/material";

import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PlantString } from "../types";
import TextInput from "../../../main/components/TextInput";
import { useEffect } from "react";

const schema = yup.object({
  amount: yup.number().required("Campo obrigatório"),
  power: yup.number().required("Campo obrigatório"),
});

// Defina o tipo para o Resolver
type MyResolver = Resolver<PlantString, yup.InferType<typeof schema>>;

interface EditStringUsinaProps {
  uG: {
    components?: {
      string?: {
        amount?: number;
        power?: number;
      };
    };
  };
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  updateStateContent: (
    field: string,
    objectName: string,
    value?: number
  ) => void;
  // handleSave: () => void;
}

const EditStringsUsina: React.FC<EditStringUsinaProps> = ({
  uG,
  isEditing,
  // setIsEditing,
  // handleSave,
  updateStateContent,
}) => {
  // const path = window.location.pathname;
  // const usinaId = path.split("/")[2];

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
    watch,
  } = useForm<PlantString>({
    defaultValues: {
      amount: uG?.components?.string?.amount || 0,
      power: uG?.components?.string?.power || 0,
    },
    resolver: yupResolver(schema) as MyResolver,
  });
  const data = watch();
  console.log("DADOS DO String:", data);
  type StringField = keyof PlantString;

  const handleStringValueChange = (field: StringField, value: string) => {
    const numericValue = value === "" ? undefined : Number(value);
    setValue(field, numericValue);
  };

  const onSubmit: SubmitHandler<PlantString> = async (data) => {
    console.log("onSubmit acionado no filho:", data);

    // Use a função handleInverterValueChange para manipular a mudança de campo
    handleStringValueChange("amount", String(data.amount));
    handleStringValueChange("power", String(data.power));

    // Atualize o estado no componente pai, condicionalmente
    if (uG?.components?.string?.amount !== data.amount) {
      updateStateContent("amount", "string", data.amount);
    }
    if (uG?.components?.string?.power !== data.power) {
      updateStateContent("power", "string", data.power);
    }
    console.log("Formulário submetido com:", data);
  };

  const amount = watch("amount");
  const power = watch("power");
  useEffect(() => {
    console.log(
      "Atualizando amount no componente pai para:",
      getValues("amount")
    );
    updateStateContent("amount", "string", getValues("amount"));
    // }
  }, [amount]);

  useEffect(() => {
    console.log(
      "Atualizando power no componente pai para:",
      getValues("power")
    );
    updateStateContent("power", "string", getValues("power"));
  }, [power]);

  return (
    <Grid
      container
      sx={{
        padding: "20px",
        flexDirection: "row",
        display: "flex",
        backgroundColor: "rgba(217, 217, 217, 0.1)",
        borderRadius: 2,
        marginTop: "8px",
        marginBottom: "8px",
        rowGap: "16px ",
        width: "100%",
      }}
      //   onSubmit={handleSubmit(onSubmit)}
    >
      <Grid item xs={6} textAlign={"start"}>
        <Typography>String</Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid
          container
          spacing={2}
          sx={{
            padding: "20px",
          }}
          onSubmit={handleSubmit(onSubmit)}
        >
          {isEditing ? (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"Quantidade"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="power"
                  label={"Potência"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              {/*  */}
            </>
          ) : (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"Quantidade"}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="power"
                  label={"Potência "}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
            </>
          )}
          {/* <Button type="submit" onClick={handleSaveAndExitEditMode}>
            Salvar Dados
          </Button> */}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditStringsUsina;
